//==========================================================
// AUTH
//==========================================================
export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";

export const LOGOUT = "LOGOUT";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";

export const GET_IS_AUTH = "GET_IS_AUTH";
export const GET_IS_AUTH_SUCCESS = "GET_IS_AUTH_SUCCESS";
export const GET_IS_AUTH_ERROR = "GET_IS_AUTH_ERROR";

export const SET_LOADING = "SET_LOADING";

export const CAN_LOGIN_SUCCESS = "CAN_LOGIN_SUCCESS";

//==========================================================
// MFA
//==========================================================
export const MFA_REQUIRED = 'MFA_REQUIRED';
export const MFA_VERIFY = 'MFA_VERIFY';
export const MFA_VERIFY_SUCCESS = 'MFA_VERIFY_SUCCESS';
export const MFA_VERIFY_ERROR = 'MFA_VERIFY_ERROR';
export const MFA_CLEAR = 'MFA_CLEAR';
export const MFA_HYDRATE = 'MFA_HYDRATE';

//==========================================================
// USER
//==========================================================
export const GET_USER_PROFILE = "GET_USER_PROFILE";
export const USER_PROFILE_SUCCESS = "USER_PROFILE_SUCCESS";
export const USER_PROFILE_SAVE = "USER_PROFILE_SAVE";

export const USER_ENTITIES = "USER_ENTITIES";
export const USER_ENTITIES_SAVE = "USER_ENTITIES_SAVE";
export const USER_MODULES_SAVE = "USER_MODULES_SAVE";
export const USER_MODULES = "USER_MODULES";
export const USER_DATE = "USER_DATE";
export const USER_DATE_SAVE = "USER_DATE_SAVE";
export const SESSION_TIMEOUT = "SESSION_ TIMEOUT";

//==========================================================
// SETTINGS
//==========================================================
export const SET_CULTURES = "SET_CULTURES";
export const SET_CULTURES_SUCCESS = "SET_CULTURES_SUCCESS";

export const GET_GS_MODULE_ACTIVE = "GET_GS_MODULE_ACTIVE";
export const GET_GS_MODULE_ACTIVE_SUCCESS = "GET_GS_MODULE_ACTIVE_SUCCESS";

export const SHOW_ENTITIES = "SHOW_ENTITIES";
export const SET_SHOW_ENTITIES = "SET_SHOW_ENTITIES";
